
const compraGridConfig = {
  idField: "idCompra",
  columns: [
    { header: "Data", field: "DATA_COMPRA" },
    { header: "Fornecedor", field: "NOME_FANTASIA" },
    { header: "Produto", field: "DESCRICAO" },
    { header: "Observações", field: "OBSERVACOES" },
    { header: "Cancelada", field: "CANCELADA",
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default compraGridConfig;